import React from 'react'
import { Usabilla } from '@fs/zion-usabilla'

/**
 * @describe - Conditionally display the Usabilla feedback button on all FNA pages except for PDF pages.
 */
export default function FnaUsabilla() {
  const showUsabilla = !window?.location?.pathname?.includes('/pdf')

  if (showUsabilla) return <Usabilla url="//w.usabilla.com/5931fccf85a5.js" />
  return null
}
